<section>

    <img src="assets/images/1-2.png" alt="Banner SSR" class="img-fluid w-100">

    <div class="container py-4">
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <div class="row  align-items-end">
                    <div class="col-12 text-center pb-5">
                        <h2 class="text-dark  p-3 d-inline-block">
                            <a href="/" class="text-decoration-none text-primary">Inicio</a> - Mujer,
                            Cuerpo y Salud
                        </h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="container py-2">
    <!-- Motivación -->
    <div class="row g-4 mb-5" id="motivacion">
        <div class="col-md-6 animate__animated animate__fadeInUp">
            <div class="about-content">
                <h3 class="mb-3">Motivación</h3>
                <hr class="my-3">
                <p>La educación en el marco de los Derechos Fundamentales Humanos (DFH) y a su vez en relación
                    con
                    los objetivos del Desarrollo del Milenio, garantiza que personas con y sin discapacidad
                    puedan
                    acceder a una educación de calidad y que se promueva el multilingüismo en la educación
                    mediante
                    la incorporación de idiomas locales/indígenas (UNESCO, 2008). En el caso de personas sordas
                    es
                    indispensable permitir su acceso a la educación en la esfera de la salud con énfasis en la
                    Salud
                    Sexual y Reproductiva (SSR) mediante la implementación del bilingüismo a través de
                    herramientas
                    de aprendizaje basadas en Tecnologías de la Información y Comunicación al servicio de la
                    inclusión educativa.</p>
            </div>
        </div>

        <div class="col-md-6 animate__animated animate__fadeInUp">
            <div class="ratio ratio-16x9">
                <video controls poster="assets/images/4.png">
                    <source src="videos/ssr/Intro.mp4" type="video/mp4">
                </video>
            </div>
        </div>
    </div>
</section>
<section class="container py-2">

    <!-- Problemática -->
    <div class="row g-4 mb-5" id="problematica">
        <div class="col-md-6 animate__animated animate__fadeInUp">
            <div class="about-content">
                <h3 class="mb-3">Problemática</h3>
                <hr class="my-3">
                <p>Según la OMS, alrededor de 466 millones de personas a nivel mundial tienen pérdida de
                    audición
                    discapacitante, incluidos 34 millones de niñas/os (OMS, 2019). En Ecuador según el Consejo
                    Nacional para la Igualdad de Discapacidades (CONADIS) hasta la fecha se registran 65.050
                    personas con discapacidad auditiva en todo el país, de estas 15.058 son mujeres entre 13 y
                    65
                    años de edad. La falta de programas y planes estratégicos basados en bilingüismo para
                    personas
                    sordas en la esfera de la SSR constituye parte de las barreras sociales que impiden el
                    acceso a
                    la educación en SSR (ver Fig. 1).</p>
            </div>
        </div>

        <div class="col-md-6 animate__animated animate__fadeInUp">
            <div class="accordion" id="problematicaAccordion">
                <!-- Item 1 -->
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne">
                        <button class="accordion-button" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            Problemática en estadísticas
                        </button>
                    </h2>
                    <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                        data-bs-parent="#problematicaAccordion">
                        <div class="accordion-body">
                            <p>Como consecuencia no existe un adecuado ejercicio de los Derechos Sexuales y
                                Reproductivos (DSR) y se observan múltiples consecuencias como por ejemplo:
                                contagio
                                de Infecciones de Transmisión Sexual (ITS), <strong>VIH (36,7 millones de
                                    infectados)</strong>, <strong>VPH (290 millones)</strong>, <strong>sífilis
                                    (más
                                    de 900 mil mujeres)</strong>, <strong>gonorrea (78 millones)</strong> entre
                                otras ITS (Organización Mundial de la Salud 2019).</p>
                        </div>
                    </div>
                </div>

                <!-- Item 2 -->
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            Embarazo en adolescentes
                        </button>
                    </h2>
                    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                        data-bs-parent="#problematicaAccordion">
                        <div class="accordion-body">
                            <p>También se observa incremento de embarazos en adolescentes (16 millones entre 15
                                y 19
                                años, 1 millón de menores de 15 años dan a luz cada año), abortos peligrosos en
                                adolescentes (3 millones cada año) (OMS, 2019).</p>
                        </div>
                    </div>
                </div>

                <!-- Item 3 -->
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThree">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                            Prácticas de violencia
                        </button>
                    </h2>
                    <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                        data-bs-parent="#problematicaAccordion">
                        <div class="accordion-body">
                            <p>Finalmente cabe mencionar las prácticas de violencia que afectan a personas
                                sordas,
                                entre el 55% y el 91% de las niñas sordas se enfrentan a una situación de abuso
                                sexual (Terzis, 2018), y 1 de cada 3 mujeres sordas son víctimas de agresión
                                sexual
                                (Stanley, 2018).</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="container py-2">
    <!-- Imagen Fig.1 -->
    <div class="row mb-5">
        <div class="col-12 text-center">
            <img src="assets/images/Figure1.png" alt="Percepción de mujeres sordas" class="img-fluid"
                style="max-width: 800px;">
            <p class="mt-3"><strong>Fig.1</strong> Percepción de mujeres sordas según su condición auditiva y
                edad
                respecto a las barreras sociales que impiden el acceso a la educación en SSR.</p>
        </div>
    </div>
</section>
<section class="container py-2">

    <!-- Propuesta -->
    <div class="row mb-5" id="propuesta">
        <div class="col-12 animate__animated animate__fadeInUp">
            <div class="about-content">
                <h3 class="mb-3">Propuesta</h3>
                <hr class="my-3">
                <p>La plataforma tiene como finalidad el brindar capacitación virtual para mejorar el acceso a
                    la
                    educación en SSR, empleando para ello metodologías que establezcan un modelo de aprendizaje
                    significativo avalada en estándares de accesibilidad en el contexto de la formación virtual
                    y el
                    desarrollo web, considerando planes de estudio que estén conceptualizados según las
                    necesidades
                    del usuario - estudiante, basándonos en sus perfiles de aprendizaje. A continuación se
                    describe
                    los módulos más relevantes y sus funcionalidades.</p>
            </div>
        </div>
    </div>

    <!-- Imagen Fig.2 -->
    <div class="row mb-5">
        <div class="col-12 text-center">
            <img src="assets/images/Figure2.png" alt="Arquitectura del sistema" class="img-fluid"
                style="max-width: 800px;">
            <p class="mt-3"><strong>Fig.2</strong> Arquitectura general del sistema compuesto por sus procesos y
                módulos principales</p>
        </div>
    </div>
</section>
<section class="container py-2">
    <!-- Resultados -->
    <div class="row g-4 mb-5" id="resultados">
        <div class="col-md-6 animate__animated animate__fadeInUp">
            <div class="text-center">
                <img src="assets/images/Figure3.png" alt="Percepción de la plataforma" class="img-fluid"
                    style="max-width: 550px;">
                <p class="mt-3"><strong>Fig.3</strong> Percepción de mujeres y adolescentes sordas respecto a la
                    plataforma educativa para mejorar el acceso a la educación en SSR.</p>
            </div>
        </div>

        <div class="col-md-6 animate__animated animate__fadeInUp">
            <div class="about-content">
                <h3 class="mb-3">Resultados</h3>
                <hr class="my-3">
                <p>La construcción de la plataforma educativa ha tenido un alto impacto en adolescentes y
                    mujeres
                    sordas medido a través de encuestas traducidas a Lengua de Señas Ecuatoriana (LSEC).
                    Mediante la
                    encuesta se pudo determinar que las beneficiarias directas encuestadas perciben como
                    altamente
                    positivo el impacto de la plataforma sobre la esfera de la SSR (ver Fig. 3), ya que mejora
                    el
                    acceso a la información y educación de calidad en SSR. Es decir, consideran que la
                    plataforma es
                    capaz de facilitar el acceso a contenidos educativos en ITS, DSR, planificación familiar y
                    control prenatal (Oyola, et al, 2018; Robles, et al 2018). Igualmente existe una aceptación
                    y
                    percepción altamente positivas por parte de las beneficiarias en cuanto a los contenidos
                    educativos del material audiovisual de la plataforma educativa. Este resultado se observó
                    mediante entrevistas semiestructuradas con estudiantes sordas entre 18 a 23 años, ellas
                    indican
                    que están plenamente reconocidas e identificadas como personas sordas en estas herramientas
                    de
                    inclusión educativa, pues se les facilita material traducido a LSEC. Esto último motiva a
                    las
                    estudiantes sordas a aprender contenidos sobre SSR, e indican también que han podido
                    aprender
                    nuevas señas y nuevos conocimientos en SSR y fáciles de comprender, y aplicarlos en su vida
                    diaria.</p>
            </div>
        </div>
    </div>
</section>

<section class="container py-2">
    <!-- Beneficiarios -->
    <div class="row mb-5 justify-content-center">
        <div class="col-md-4 mb-4 animate__animated animate__fadeInUp">
            <div class="card h-100 border-0 shadow">
                <div class="card-body text-center p-4">
                    <h2 class="display-4 text-primary mb-3"><strong>64</strong></h2>
                    <img src="assets/images/a1.png" alt="Beneficiarios directos" class="img-fluid mb-3"
                        style="max-width: 150px;">
                    <h5 class="card-title"><strong>Beneficiarios Directos</strong></h5>
                </div>
            </div>
        </div>

        <div class="col-md-4 mb-4 animate__animated animate__fadeInUp">
            <div class="card h-100 border-0 shadow">
                <div class="card-body text-center p-4">
                    <h2 class="display-4 text-primary mb-3"><strong>460.586</strong></h2>
                    <img src="assets/images/a2.png" alt="Beneficiarios indirectos" class="img-fluid mb-3"
                        style="max-width: 150px;">  
                    <h5 class="card-title"><strong>Beneficiarios Indirectos</strong></h5>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="container py-2">
    <!-- Recursos descargables -->
    <div class="row g-4 mb-5" id="recursosdescargables">
        <div class="col-md-6 animate__animated animate__fadeInUp">
            <div class="about-content">
                <h3 class="mb-3">Recursos descargables</h3>
                <hr class="my-3">

                <h4 class="mt-4">Enlaces plataforma:</h4>
                <p>- Plataforma Educativa <a href="http://mesade.org/mcs/" target="_blank"
                        class="text-decoration-none">: Ver Mujer, Cuerpo y Salud</a></p>

                <h4 class="mt-4">Producción científica:</h4>
                <p>- An intelligent ecosystem to improve the information access and knowledge development about
                    sexual and reproductive health on deaf women in Cuenca, Ecuador <a href="http://cort.as/-HVnq"
                        target="_blank" class="text-decoration-none">(http://cort.as/-HVnq)</a></p>
                <p>- An Expert System to Provide Sexual and Reproductive Health Educational Contents for Young
                    Deaf
                    Women <a href="http://cort.as/-HVo-" target="_blank"
                        class="text-decoration-none">(http://cort.as/-HVo-)</a></p>

                <h4 class="mt-4">Para desarrolladores:</h4>
                <p>- Source code Expert System: <a href="http://mesade.org/lcm/" target="_blank"
                        class="text-decoration-none">: Acceder código</a></p>
            </div>
        </div>

        <div class="col-md-6 animate__animated animate__fadeInUp">
            <div class="text-center">
                <img src="assets/images/descargarecursos.png" alt="Recursos descargables" class="img-fluid"
                    style="max-width: 500px;">
            </div>
        </div>
    </div>

</section>
<section class="container py-2">
    <!-- Equipo -->
    <div class="row mb-5" id="equipo">
        <div class="col-12 text-center mb-5 animate__animated animate__fadeInUp">
            <h2>Equipo</h2>
        </div>

        <!-- Fila 1 -->
        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/yrobles.png'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h3 class="h5">Yaroslava Robles Bykbaev</h3>
                    <p class="mb-1">Médica</p>
                    <p class="small">Magister en investigación de la salud</p>
                </div>
            </div>
        </div>

        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/pingavelez.jpg'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h3 class="h5">Paola Ingavélez Guerra</h3>
                    <p class="mb-1">Ingeniero</p>
                    <p class="small">Ingeniero en Sistemas, Magister en Diseño Multimedia, Especialista en
                        Desarrollo Intelectual</p>
                </div>
            </div>
        </div>

        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/user.jpg'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h3 class="h5">Franscisco Galán Montesdeoca</h3>
                    <p class="mb-1">Doctor PH.D</p>
                    <p class="small">Dentro del programa en integración y desarrollo económico y territorial.
                    </p>
                </div>
            </div>
        </div>

        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/fpesantez.jpg'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h3 class="h5">Fernando Pesantez Aviles</h3>
                    <p class="mb-1">Doctor PH.D</p>
                    <p class="small">Doctor en ciencia de la educación.</p>
                </div>
            </div>
        </div>

        <!-- Fila 2 -->
        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/vrobles.jpg'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h3 class="h5">Vladimir Robles Bykbaev</h3>
                    <p class="mb-1">Doctor PH.D</p>
                    <p class="small">Doctor en Tecnologías de la información y las comunicaciones.</p>
                </div>
            </div>
        </div>

        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/user.jpg'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h3 class="h5">Chistian Oyola Flores</h3>
                    <p class="mb-1">Ingeniero</p>
                    <p class="small">Ingeniero en Sistemas</p>
                </div>
            </div>
        </div>

        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/jHilera.png'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h3 class="h5">José Ramón Hilera González</h3>
                    <p class="mb-1">Doctor PH.D Ciencias (Matemáticas)</p>
                    <p class="small">Departamento de Ciencias de la Computación - Escuela Politécnica Superior -
                        Universidad de Alcalá</p>
                </div>
            </div>
        </div>

        <div class="col-md-3 mb-4 animate__animated animate__fadeInUp">
            <div class="team-member card h-100 border-0 shadow">
                <div class="member-photo"
                    style="background-image: url('assets/images/equipo_de_trabajo/sOton.png'); height: 350px; background-size: cover; background-position: center;">
                </div>
                <div class="card-body">
                    <h3 class="h5">Salvador Otón Tortosa</h3>
                    <p class="mb-1">Doctor PH.D Ingenieria de la Información y el Conocimiento</p>
                    <p class="small">Departamento de Ciencias de la Computación - Escuela Politécnica Superior -
                        Universidad de Alcalá</p>
                </div>
            </div>
        </div>
    </div>
</section>